module.exports = __webpack_public_path__ + "img/header-engagementRingsLabGrownDiamonds@2x.56e87e2.jpg";